import { ThisConnector } from '../../../../api/connector'

export interface NewNotificationsCountArgs {
  organizationUuid: string
}

export interface GetNewNotificationsCountResponse {
  count: number
}

export async function getNewNotificationsCount(
  this: ThisConnector,
  { organizationUuid }: NewNotificationsCountArgs
) {
  const { count } = await this.connector.get<GetNewNotificationsCountResponse>(
    `/${organizationUuid}/notifications/count/new?expand=skip_links`
  )
  return count
}
